const apiGateway = 'http://localhost:8090';
export const environment = {
  api: 'api',
  url: 'https://preprod.checkout-sdk.cydeo.com',
  shopUrl: 'https://preprod.checkout-backend.cydeo.com/api/v1',
  stripeKey: 'pk_live_51IGX5yCtKIAKC0qWQr9gedRcOx4BIKHbRJlSNo2QoZR3O5Xdcc6R1uYhBBwzJYHWm6r8Kl1VLbmNoHZ1WWQZ8rT500cpTpuMBs',
  payment_method_configuration: 'pmc_1O8ulICtKIAKC0qWHFWejZ6B',
  hello_sign_client_id: '8e9d120ee42a1f9e528cf7295aba374b'
}
